import { action } from 'easy-peasy';
import { IActionDeleteTemplate } from '../types';

const deleteTemplate: IActionDeleteTemplate = action((state, id) => {
  state.items = state.items.filter(item => item.id !== id);
});

export default deleteTemplate;
